import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Meta} from '@angular/platform-browser';
import {EnvironmentService} from '../../_services/environment.service';
import {SiteConfigService} from '../../_services/site-config.service';
import { Router } from '@angular/router';
import { ApiService } from '../../_services/api.service';
import {UserService} from '../../_services/user.service';

@Component({
    selector: 'app-enotification',
    templateUrl: './enotification.component.html',
    styleUrls: ['./enotification.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EnotificationComponent implements OnInit {

  siteConfigService = inject(SiteConfigService);
  private readonly userService = inject(UserService);

  constructor(private metaService: Meta,
              public envService: EnvironmentService,
              private router: Router,
              private apiService: ApiService) { }

  ngOnInit(): void {
    this.metaService.updateTag({ name: 'keywords', content: 'Los Angeles County Assessor’s Property Owner e-Notification Alert,Los angeles assessor, enotification, los angeles county' });
  }

  get buttonClass(): string {
    return this.siteConfigService.isENotificationDisabled() ? 'btn btn-primary disabled-link' : 'btn btn-primary';
  }

  get buttonToolTip(): string {
    return this.siteConfigService.getENotificationMaintenanceMessage();
  }

  goToENotification(): void {
    globalThis.location.href = this.envService.getExistingUsersUrl();

    // if (this.userService.isLoggedIn()) {
    //   this.router.navigate(['/efile/enotification']);
    // } else {
    //
    //   const queryParams = { returnUrl: '/efile/enotification' };
    //
    //   this.router.navigate(['/login'], { queryParams }).then(() => {
    //     window.location.reload();
    //   });
    //
    // }
  }

}
